import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  type?: string;
  url?: string;
  image?: string;
  canonical?: string;
  schemaMarkup?: object | object[];
  speakable?: boolean;
}

const SEO = ({ 
  title = "BetterByAI | Transform Your Business with AI Solutions",
  description = "Boost efficiency and revenue with custom AI solutions for your business. Our expert team delivers ROI-focused automation, generative AI implementation, and intelligent systems that transform operations.",
  keywords = "AI solutions, RAG bots, machine learning services, AI web applications, business automation, ai agency, agency uk, ai automation agency bedfordshire, ai agency london, generative ai",
  type = "website",
  url = "https://betterbyai.com", 
  image = "https://betterbyai.com/logo.png",
  canonical,
  schemaMarkup,
  speakable = false
}: SEOProps) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="BetterByAI Logo" />
      
      {/* Favicon tags - comprehensive solution for all browsers and Google */}
      <link rel="icon" href="/favicon.ico" sizes="any" />
      <link rel="icon" type="image/png" href="/assets/bbfav-32x32.png" sizes="32x32" />
      <link rel="icon" type="image/png" href="/assets/bbfav-16x16.png" sizes="16x16" />
      <link rel="apple-touch-icon" href="/assets/bbfav-180x180.png" sizes="180x180" />
      
      {/* Fix for canonical - Add a conditional check */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Schema markup */}
      {schemaMarkup && (
        Array.isArray(schemaMarkup) 
          ? schemaMarkup.filter(Boolean).map((schema, index) => (
              <script type="application/ld+json" key={`schema-${index}`}>
                {JSON.stringify(schema)}
              </script>
            ))
          : (
            <script type="application/ld+json">
              {JSON.stringify(schemaMarkup)}
            </script>
          )
      )}

      {/* Speakable schema for voice search */}
      {speakable && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "speakable": {
              "@type": "SpeakableSpecification",
              "cssSelector": ["h1", ".main-content p", ".faq-section"]
            },
            "url": url
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;